import React, { useEffect, useState } from "react";
import {
  CheckBoxInput,
  SelectInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import Table from "../../components/common/table/Table";
import { history } from "../../_helpers";
import { useDispatch, useSelector } from "react-redux";
import { authActions, eCardAction } from "../../_store";
import CustomLoader from "../../components/common/ui/Loader";
import ECardIcon from "../../assets/svg/ecard-icon.svg";
import Activeicon from "../../assets/svg/approved.svg";
import Inactiveicon from "../../assets/svg/inactive-user.svg";
import Visible from "../../assets/svg/visble.svg";
import NotVisible from "../../assets/svg/not-visible.svg";
import Swal from "sweetalert2";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";

function ECardList() {
  const dispatch = useDispatch();

  const { podStatusOptions, eCardViewPermission } = useSelector(
    (x) => x?.dropdownOptions
  );

  const isPageReloading = useSelector((state) => state.master?.isPageReload);
  const {
    ECardUploadSearchData,
    getEcardListResponse,
    categoriesForDropDown,
    loading,
  } = useSelector((x) => x?.ecard);
  let sorting = false;

  const [showSearchFields, setShowSearchFields] = useState(false);


  useEffect(() => {
    dispatch(eCardAction?.getEcardList(ECardUploadSearchData))
      .then((result) => {
        if (result?.payload?.DataList?.length === 0) {
          const searchParams = { ...ECardUploadSearchData };
          searchParams.PageNo = 1;
          searchParams.RowCountPerPage = 10;
          dispatch(eCardAction?.updateEcardUploadSearch(searchParams));
          dispatch(eCardAction?.getEcardList(searchParams));
        }
      })
      .catch((err) => {
        showToastNotification("Failed to fetch E-Cards", "error");
      });
    getCategoriesForDropDown();
  }, [
    ECardUploadSearchData?.RowCountPerPage,
    ECardUploadSearchData?.PageNo,
    ECardUploadSearchData?.SortBy,
    isPageReloading,
  ]);

  const getCategoriesForDropDown = () => {
    dispatch(eCardAction?.getCategoriesForDropDown());
  };

  const columns = [
    {
      name: "E-Card Name",
      key: "EcardName",
      selector: (row) => row.EcardName,
      cell: (row) => (
        <div
          className="Common_Link_Style"
          onClick={() => {
            handleECardEdit(row);
          }}
        >
          {row?.EcardName}
        </div>
      ),
      sortable: true,
    },
    {
      // width: "210px",
      name: "Category Name",
      key: "CategoryName",
      selector: (row) => row.CategoryName,
      cell: (row) => <div className="">{row.CategoryName}</div>,
      sortable: true,
    },
    {
      width: "210px",
      name: "Visible To",
      key: "VisibleTo",
      selector: (row) => row.VisibleTo,
      sortable: true,
      cell: (row) => (
        <div className="d-flex  gap-2 align-items-center">
          {row?.VisibleTo === 2 || row?.VisibleTo === 3 ? (
            <>
              {/* <i
                class="fa-solid fa-circle-check fa-xl"
                style={{ color: "#11833D" }}
                title="Inmate can view this E-Card"
              ></i> */}
              <img
                src={Visible}
                alt="inmate-view-icon"
                title="Inmate can view this E-Card"
                className="in-icon-size"
              />
              <label
                className="form-check-label font-size-14 form-label-custom-visible"
                style={{ color: "#111827", fontWeight: "400" }}
              >
                Inmate
              </label>
            </>
          ) : (
            <>
              {/* <i
                class="fa fa-times h-4"
                aria-hidden="true"
                style={{ fontSize: "22px", color: "#c8605e" }}
                title="Inmate can't view this E-Card"
              ></i> */}
              <img
                src={NotVisible}
                alt="inmate-view-icon"
                title="Inmate can't view this E-Card"
                className="in-icon-size"
              />

              <label
                className="form-check-label font-size-14 form-label-custom-visible"
                style={{ color: "#111827", fontWeight: "400" }}
              >
                Inmate
              </label>
            </>
          )}

          {row?.VisibleTo === 1 || row?.VisibleTo === 3 ? (
            // <CheckBoxInput
            //   label={"Public User"}
            //   checked={row?.VisibleTo === 1 || row?.VisibleTo === 3}
            //   disabled
            // />
            <>
              {/* <i
                class="fa-solid fa-circle-check fa-xl"
                style={{ color: "#11833D" }}
                title="Public User can view this E-Card"
              ></i> */}
              <img
                src={Visible}
                alt="inmate-view-icon"
                title="Public User can view this E-Card"
                className="in-icon-size"
              />
              <label
                className="form-check-label font-size-14 form-label-custom-visible"
                style={{ color: "#111827", fontWeight: "400" }}
              >
                Public User
              </label>
            </>
          ) : (
            <>
              {/* <i
                class="fa fa-times h-4"
                aria-hidden="true"
                style={{ fontSize: "22px", color: "#c8605e" }}
                title=" Public User can't view this E-Card"
              ></i> */}
              <img
                src={NotVisible}
                alt="inmate-view-icon"
                title="Public User can't view this E-Card"
                className="in-icon-size"
              />
              <label
                className="form-check-label font-size-14 form-label-custom-visible"
                style={{ color: "#111827", fontWeight: "400" }}
              >
                Public User
              </label>
            </>
          )}
        </div>
      ),
    },

    {
      name: "Status",
      key: "IsActive",
      selector: (row) => row.IsActive,
      sortable: true,
      cell: (row) => (
        <img
          title={row.IsActive === 1 ? "Active" : "Inactive"}
          src={row.IsActive === 1 ? Activeicon : Inactiveicon}
          alt={row.IsActive === 1 ? "Active" : "Inactive"}
          className="in-icon-size"
        />
      ),
    },
  ];

  const handleChange = (e, select) => {
    let updatedValue = { ...ECardUploadSearchData };

    if (select) {
      updatedValue[select] =
        e?.value !== undefined
          ? e.value
          : select === "VisibleTo"
            ? 0
            : select === "IsActive"
              ? 2
              : 0;
      // Always reset pagination
      updatedValue = {
        ...updatedValue,
        PageNo: 1,
        RowCountPerPage: 10,
      };
      dispatch(eCardAction?.updateEcardUploadSearch(updatedValue));
      dispatch(eCardAction?.getEcardList(updatedValue));
    } else {
      const { name, value } = e.target;
      if (value.startsWith(" ")) return;
      const isValid = /^[a-zA-Z0-9 ']*$/.test(value);
      if (!isValid) return;

      updatedValue[name] = value;
      dispatch(eCardAction?.updateEcardUploadSearch(updatedValue));
    }
  };

  const handleRowPerPage = (page) => {
    const updateSearch = { ...ECardUploadSearchData };
    updateSearch.RowCountPerPage = page;
    updateSearch.PageNo = 1;
    dispatch(eCardAction?.updateEcardUploadSearch(updateSearch));

    // setECardList(updateSearch);
    dispatch(eCardAction?.getEcardList(updateSearch));
  };

  const handlePageChange = (page) => {
    if (sorting) {
      sorting = false;
      return;
    }
    const updateSearch = { ...ECardUploadSearchData };
    updateSearch.PageNo = page;
    // setECardList(updateSearch);
    dispatch(eCardAction?.updateEcardUploadSearch(updateSearch));
    dispatch(eCardAction?.getEcardList(updateSearch));
  };

  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...ECardUploadSearchData };

    const newSortOrder = search.SortBy?.includes(column.key)
      ? search.SortBy.endsWith("ASC")
        ? "DESC"
        : "ASC"
      : "ASC";
    search.SortBy = `${column.key} ${newSortOrder}`;
    dispatch(eCardAction?.updateEcardUploadSearch(search));
  };

  const handleSearchReset = () => {
    const resetSearch = {
      EcardName: "",
      CategoryId: 0,
      IsActive: 2,
      VisibleTo: 0,
      PageNo: 1,
      RowCountPerPage: 10,
      SortBy: "EcardId DESC",
    };
    dispatch(eCardAction?.updateEcardUploadSearch(resetSearch));
    // setECardList(resetSearch);
    dispatch(eCardAction?.getEcardList(resetSearch));
  };

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    const search = { ...ECardUploadSearchData, PageNo: 1, RowCountPerPage: 10 };
    dispatch(eCardAction.getEcardList(search));
    dispatch(eCardAction.updateEcardUploadSearch(search));
  };

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const handleECardPage = () => {
    Swal?.close();
    history.navigate("/Admin/E-Cards/Upload", {
      state: {
        cardID: 0,
        isEdit: false,
      },
    });
  };

  const renderSearch = () => {
    return (
      <form onSubmit={(e) => handleSearchSubmit(e)}>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="EcardName"
                id="EcardName"
                label="E-Card Name"
                value={ECardUploadSearchData?.EcardName}
                placeholder="Enter E-Card Name"
                maxLength={50}
                handleChange={(e) => {
                  handleChange(e);
                }}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="CategoryId"
                options={categoriesForDropDown}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={ECardUploadSearchData?.CategoryId !== 0}
                label="Category"
                placeholder="Select Category"
                value={ECardUploadSearchData?.CategoryId}
                handleChange={(e) => {
                  handleChange(e, "CategoryId");
                }}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="VisibleTo"
                options={eCardViewPermission}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={ECardUploadSearchData?.VisibleTo !== 0}
                label="Visible To"
                placeholder="Select Visibility"
                value={ECardUploadSearchData?.VisibleTo}
                handleChange={(e) => {
                  handleChange(e, "VisibleTo");
                }}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="IsActive"
                options={podStatusOptions}
                isMulti={false}
                closeMenuOnSelect={true}
                isClearable={ECardUploadSearchData?.IsActive !== 2}
                label="Status"
                placeholder="Select Status"
                value={ECardUploadSearchData?.IsActive}
                handleChange={(e) => {
                  handleChange(e, "IsActive");
                }}
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex flex-wrap justify-content-center gap-3 flex-wrap">
          <Button
            variant="primary"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          />

          <Button
            variant="secondary"
            className="me-2"
            onClick={handleSearchReset}
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  const handleECardEdit = (row) => {
    Swal?.close();
    const cardID = row?.EcardId;
    history.navigate("/Admin/E-Cards/Upload", {
      state: {
        cardID: cardID,
        isEdit: true,
      },
    });
  };

  if (loading) return <CustomLoader />;

  return (
    <>
      {/* {commonFacilityCode > 0 ? ( */}
      <div className="E-Card-List">
        <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
            {/* Mobile only (Below md breakpoint) */}
            <div className=" d-block d-md-none">
              <div
                className=" d-flex align-items-center justify-content-between"
                style={{ background: "transparent", cursor: "pointer" }}
                onClick={toggleInformation}
              >
                <h2 className="form_title_uppercase text-color">
                  E-Card SEARCH
                </h2>
                <i
                  id="itagInformation"
                  className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                    }`}
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
            </div>
            {/* Mobile only (Below md breakpoint) */}
            <div className="d-block d-md-none mt-2">
              {showSearchFields && renderSearch()}
            </div>

            {/* Web only (Desktop and above) */}
            <div className="mb-3 d-none d-md-block">
              <h2 className="form_title_uppercase text-color">E-Card SEARCH</h2>
            </div>
            {/* Web only (Desktop and above) */}
            <div className="d-none d-md-block">{renderSearch()}</div>
          </div>

          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4">
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
              <h2 className="text-color">E-CARDS LIST</h2>

              <div className="d-flex flex-wrap  align-items-center gap-3">
                <Button
                  variant="success"
                  className="me-2"
                  label="upload e-card"
                  type="button"
                  imgsrc={ECardIcon}
                  status="btn-label"
                  onClick={() => {
                    handleECardPage();
                  }}
                />
              </div>
            </div>

            <Table
              columns={columns}
              data={getEcardListResponse?.DataList}
              pagination
              onChangeRowsPerPage={handleRowPerPage}
              onChangePage={handlePageChange}
              totalRowCount={getEcardListResponse?.TotalRecordCount}
              currentPage={ECardUploadSearchData?.PageNo}
              paginationPerPage={ECardUploadSearchData.RowCountPerPage}
              onSort={handleSort}
              serverSideSort
              sortColumn={ECardUploadSearchData?.SortBy?.split(" ")[0]}
              sortDirection={ECardUploadSearchData?.SortBy?.split(" ")[1]}
            />
          </div>
        </div>
      </div>
      {/* ) : (
        <h4 className="facility-card">Select a Facility Code from the list</h4>
      )} */}
    </>
  );
}

export default React.memo(ECardList);
